import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  cursor: default;
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.textColor || props.theme.color};
`;

export const Text = styled.div`
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
`;

export const IconContainer = styled.div`
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  max-width: 31px;
`;

export const Temperature = styled.div`
  transition: 0.2s all;
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
`;
